import React from "react";
import { Modal, Button } from "@/shared";

const checkmarkClass = (done) =>
  done
    ? "h-2.5 w-2.5 rounded-full bg-green-600"
    : "h-2.5 w-2.5 rounded-full bg-gray-300";

export function CoreTutorialModal({
  visible,
  steps = [],
  onSkip,
  onClose,
  onStepNavigate,
  onStepComplete,
}) {
  return (
    <Modal
      visible={visible}
      setVisible={onClose}
      onClose={onClose}
      title="Welcome to Attune Logic"
      hideFooter
      size="lg"
    >
      <div className="space-y-4">
        <p className="text-sm text-gray-600">
          Complete these setup steps to get your account ready for daily operations.
        </p>

        <div className="space-y-3">
          {steps.map((step) => (
            <div
              key={step.id}
              className="rounded-lg border border-gray-200 bg-white p-3 shadow-sm"
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="flex items-center gap-2">
                    <span className={checkmarkClass(step.completed)} />
                    <h4 className="text-sm font-semibold text-gray-900">
                      {step.title}
                    </h4>
                  </div>
                  <p className="mt-1 text-xs text-gray-600">{step.description}</p>
                </div>
              </div>
              <div className="mt-3 flex items-center gap-2">
                <Button
                  type="primary"
                  size="sm"
                  onClick={() => onStepNavigate(step)}
                >
                  {step.ctaLabel}
                </Button>
                <Button
                  type="alternative"
                  size="sm"
                  onClick={() => onStepComplete(step)}
                  disabled={step.completed}
                >
                  {step.completed ? "Completed" : "Mark Complete"}
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-between pt-2">
          <Button type="alternative" onClick={onSkip}>
            Skip for now
          </Button>
          <Button type="primary" onClick={onClose}>
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export function ContextualTutorialModal({
  visible,
  title,
  body,
  ctaLabel,
  onClose,
  onNavigate,
}) {
  return (
    <Modal
      visible={visible}
      setVisible={onClose}
      onClose={onClose}
      title={title}
      hideFooter
      size="md"
    >
      <div className="space-y-4">
        <p className="text-sm text-gray-600">{body}</p>
        <div className="flex justify-end gap-2">
          <Button type="alternative" onClick={onClose}>
            Maybe later
          </Button>
          <Button type="primary" onClick={onNavigate}>
            {ctaLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default CoreTutorialModal;
